
































































































































































































































import { Component } from 'vue-property-decorator'
import { formatTimestamp, getPassedTime } from '@/utils/utils'
import VueBase from '@/VueBase'
import request from '@/utils/request'
import qs from 'qs'
import Sync from '../vuln/components/sync.vue'

@Component({
  name: 'VulnDetail',
  components: {
    Sync,
  },
})
export default class VulnDetail extends VueBase {
  private sliderWarpContract = false
  private deleteDialogOpen = false
  private logDialogOpen = false
  fmtTime(time: any) {
    if (time) {
      const data = new Date(time).getTime() / 1000
      return formatTimestamp(data)
    }
    return ''
  }

  async openUrl(url: any) {
    window.open(url)
  }

  get CVENUMBERS() {
    const res = []
    for (let key in this.assetVulDetail.base_info) {
      switch (key) {
        case 'cnnvd':
          res.push({
            label: this.assetVulDetail.base_info[key],
            link: `http://www.cnnvd.org.cn/web/xxk/ldxqById.tag?CNNVD=${this.assetVulDetail.base_info[key]}`,
          })
          break
        case 'cnvd':
          res.push({
            label: this.assetVulDetail.base_info[key],
            link: `https://www.cnvd.org.cn/flaw/show/${this.assetVulDetail.base_info[key]}`,
          })
          break
        case 'cve':
          res.push({
            label: this.assetVulDetail.base_info[key],
            link: `https://cve.mitre.org/cgi-bin/cvename.cgi?name=${this.assetVulDetail.base_info[key]}`,
          })
          break
        case 'cwe':
          const cwe =
            this.assetVulDetail.base_info[key] &&
            this.assetVulDetail.base_info[key][0]
          res.push({
            label: cwe,
            link: `https://cwe.mitre.org/data/definitions/${cwe}.html`,
          })
          break
      }
    }
    return res
  }

  private openWindow(link: string) {
    window.open(link)
  }

  private settingInte: any = []
  private assetVulDetail: any = {}

  goBack = () => {
    this.$router.push({
      name: 'vulnList',
    })
  }

  private levelColor(level: any) {
    switch (level) {
      case '严重':
        return '#E56363'
      case '高危':
        return '#F49E0B'
      case '中危':
        return '#2F90EA'
      case '低危':
        return '#ABB2C0'
      case '提示':
        return '#DBDBDB'
    }
  }

  private statusOptions: Array<any> = [
    {
      value: this.$t('views.vulnDetail.reported'),
      label: this.$t('views.vulnDetail.reported'),
    },
    {
      value: this.$t('views.vulnDetail.confirmed'),
      label: this.$t('views.vulnDetail.confirmed'),
    },
    {
      value: this.$t('views.vulnDetail.fixed'),
      label: this.$t('views.vulnDetail.fixed'),
    },
    {
      value: this.$t('views.vulnDetail.ignored'),
      label: this.$t('views.vulnDetail.ignored'),
    },
  ]

  private tableData: Array<any> = []
  private page = 1
  private keyword = ''
  private selectedId = 0
  private total = 0

  private orderOptions = [
    {
      label: this.$t('views.vulnList.orderOptions.type'),
      value: 'type',
    },
    {
      label: this.$t('views.vulnList.orderOptions.level'),
      value: 'level',
    },
    {
      label: this.$t('views.vulnList.orderOptions.url'),
      value: 'url',
    },
    {
      label: this.$t('views.vulnList.orderOptions.latest_time'),
      value: 'latest_time',
    },
    {
      label: this.$t('views.vulnList.orderOptions.first_time'),
      value: 'first_time',
    },
  ]

  private syncInfo: any = {}
  private aggr_id: any = 0
  async init() {
    this.aggr_id = parseInt(this.$route.params.page)
    this.selectedId = parseInt(this.$route.params.id)
    await this.getAssetVulDetail()
    this.syncInfo = {
      source_type: 2,
      id: this.aggr_id,
      create_time: this.assetVulDetail.base_info.first_time,
      // last_time: this.assetVulDetail.base_info.last_time,
      type_name: this.assetVulDetail.base_info.vul_type,
      package_language: this.assetVulDetail.base_info.language,
      vul_number:
        (this.assetVulDetail.base_info.cnnvd
          ? this.assetVulDetail.base_info.cnnvd + ' | '
          : '') +
        (this.assetVulDetail.base_info.cnvd
          ? this.assetVulDetail.base_info.cnvd + ' | '
          : '') +
        (this.assetVulDetail.base_info.cve
          ? this.assetVulDetail.base_info.cve + ' | '
          : '') +
        (this.assetVulDetail.base_info.cwe
          ? this.assetVulDetail.base_info.cwe + ' | '
          : ''),
      level_id: this.assetVulDetail.base_info.level,
      vul_name: this.assetVulDetail.base_info.vul_title,
      pro_info: this.assetVulDetail.base_info.project_names,
    }
  }

  async getAssetVulDetail() {
    const res = await this.services.sca.assetVulDetail({
      aggr_id: this.aggr_id, //组件列表id
      vul_package_id: this.selectedId, //组件漏洞id
    })
    if (res.status !== 201) {
      this.$message.error(res.msg)
      return
    }
    this.assetVulDetail = res.data
  }

  async created() {
    this.init()
  }

  // private async changeStatus(val: any) {
  //   const res = await this.services.vuln.changeStatus({
  //     id: this.selectedId,
  //     status_id: val,
  //   })
  //   if (res.status === 201) {
  //     this.$message({
  //       type: 'success',
  //       message: res.msg,
  //       showClose: true,
  //     })
  //   } else {
  //     this.$message({
  //       type: 'error',
  //       message: res.msg,
  //       showClose: true,
  //     })
  //   }
  // }

  private async vulnDelete() {
    this.loadingStart()
    const { status, msg } = await this.services.vuln.vulnDelete(this.selectedId)
    this.loadingDone()
    if (status !== 201) {
      this.$message({
        type: 'error',
        message: msg,
        showClose: true,
      })
    } else {
      this.$message({
        type: 'success',
        message: msg,
        showClose: true,
      })
      this.$router.push('/vuln/vulnList')
    }
  }

  private logList: any = []
  async vullogBtn() {
    const res = await this.services.vuln.vullog(this.$route.query.id, '2')
    this.logList = res.status
    this.logDialogOpen = true
  }
  // exportVul() {
  //   var projectName = this.assetVulDetail.base_info.project_names[0]
  //   request
  //     .get(
  //       `project/export?vid=${this.selectedId}&pid=${this.vulnObj.vul.project_id}`,
  //       {
  //         responseType: 'blob',
  //       }
  //     )
  //     .then((res: any) => {
  //       if (res.type === 'application/json') {
  //         this.$message.error({
  //           message: this.$t('views.vulnDetail.exportFail') as string,
  //           showClose: true,
  //         })
  //       } else {
  //         const blob = new Blob([res], {
  //           type: 'application/octet-stream',
  //         })
  //         const link = document.createElement('a')
  //         link.href = window.URL.createObjectURL(blob)
  //         link.download = projectName + '.doc'
  //         link.click()
  //         this.$message.success({
  //           message: this.$t('views.vulnDetail.exportSuccess') as string,
  //           showClose: true,
  //         })
  //       }
  //     })
  //     .catch(() => {
  //       this.$message.error({
  //         message: this.$t('views.vulnDetail.exportFail') as string,
  //         showClose: true,
  //       })
  //     })
  // }

  private async recheckVul() {
    const params = {
      ids: this.selectedId.toString(),
    }
    const { status, msg } = await this.services.vuln.vulRecheck(params)
    if (status !== 201) {
      this.$message({
        type: 'error',
        message: msg,
        showClose: true,
      })
    } else {
      this.$message({
        type: 'success',
        message: msg,
        showClose: true,
      })
    }
  }
}
